import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';

/**
 * Homepage class.
 */
export default class Accordion extends withBreakpointObserver(Base) {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'Accordion',
    refs: ['btnOpen'],
    options: {
      activeBreakpoints: {
        type: String,
        default: 'xxs xs s',
      },
    },
  };

  /**
   * Handle open/close accordion content
   * @returns {void}
   */
  onBtnOpenClick() {
    this.$el.classList.toggle('accordion--open');
  }
}
